module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "history"
  }, [_c('div', {
    staticClass: "block"
  }), _vm._v(" "), _c('div', {
    staticClass: "historybg01"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/texture/historybg01.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "historybg02"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/texture/historybg02.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "txtcontent strip wow fadeInUp",
    attrs: {
      "data-wow-duration": "1s",
      "data-wow-delay": "0"
    }
  }, [_c('h2', {
    staticClass: "wow1"
  }, [_c('img', {
    attrs: {
      "src": require("../../asset/svg/title/history1.svg"),
      "alt": "關於韓淑華老師"
    }
  }), _c('br', {
    staticClass: "m_only"
  }), _c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../../asset/svg/title/history2.svg"),
      "alt": "與多寶藝術學堂"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aboutteacher"
  }, [_c('img', {
    staticClass: "wow2",
    attrs: {
      "src": require("../../img/teacher.jpg"),
      "alt": "韓淑華老師"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wow3"
  }, [_c('span', [_vm._v("韓淑華老師")]), _c('br'), _vm._v("畢業於國立台北藝術大學，在藝術領域擔任策展推廣工作。機緣遇到一群生命特質特殊的孩子，因熱愛而投入帶著這些孩子玩顏色、玩線條、玩造形。引導孩子發展每一個生命本質所俱有的創作力量，以及呈現藝術形式中屬於他們的原生樣貌。未來希望能催生一所屬於這群生命特別孩子的適性學校，瞭解尊重他們特有的生命差異，引導開發出屬於他們的天賦潛能。讓他們在困難的生命裡，也能以自己最喜歡、擅長，且精彩的能力來安身立命。")])])]), _vm._v(" "), _c('div', {
    staticClass: "historylist"
  }, [_c('div', {
    staticClass: "bao_txt"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/bao.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "y_banana"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/y_banana.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "redchair"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/redchair.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "oldbrick"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/oldbrick.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    staticClass: "item down"
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("1992.")]), _vm._v(" "), _c('p', [_vm._v("畢業於國立藝術學院美術系(現為國立台北藝術大學)")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("1992 - 1994.")]), _vm._v(" "), _c('p', [_vm._v("參與籌備成立"), _c('b', [_vm._v("淡水藝文中心")]), _vm._v("，從事藝術策展推廣工作。"), _c('br'), _vm._v("參與籌備成立"), _c('b', [_vm._v("淡水文化基金會")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("1995.")]), _vm._v(" "), _c('p', [_vm._v("成立美術教學工作室")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("1997 - 2015.")]), _vm._v(" "), _c('p', [_vm._v("任教自閉症兒童"), _c('b', [_vm._v("藝術潛能開發課程")]), _vm._v("於"), _c('br'), _vm._v("台北縣自閉症潛能發展中心")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("1999.")]), _vm._v(" "), _c('p', [_vm._v("開始以一對一個別引導方式，啓發自閉症孩子畫出心裡的世界")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2003.")]), _vm._v(" "), _c('p', [_vm._v("策展台北縣自閉症潛能發展中心"), _c('b', [_vm._v("界外藝術")]), _vm._v("首展，"), _c('br'), _vm._v("於清華大學人文社會學院展覽")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2004.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("界外藝術")]), _vm._v("巡迴展，於淡江大學、輔仁大學、台北縣政府展出")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2003 - 2007.")]), _vm._v(" "), _c('p', [_vm._v("策劃展覽及編輯"), _c('b', [_vm._v("界外藝術")]), _vm._v("4本作品集")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2007 - 2015.")]), _vm._v(" "), _c('p', [_vm._v("與孩子們的父母共同規劃每年的"), _c('b', [_vm._v("寫生旅行")]), _vm._v("，"), _c('br'), _vm._v("走過蘭嶼、澎湖、馬祖、小琉球、台東、花蓮、南投…在島嶼各地寫生旅行")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2008.")]), _vm._v(" "), _c('p', [_vm._v("參與林正盛導演策劃拍攝關於泛自閉症孩子的紀錄片"), _c('b', [_vm._v("一閃一閃亮晶晶")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2009.")]), _vm._v(" "), _c('p', [_vm._v("與台北藝術大學"), _c('b', [_vm._v("藝術服務學習課程")]), _vm._v("合作，學生駱怡初、吳柏均、高健騰到藝術大學上"), _c('b', [_vm._v("媒材創作運用課程")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2010.")]), _vm._v(" "), _c('p', [_vm._v("「一閃一閃亮晶晶」紀錄片於台灣上映。同時發行同名書，為"), _c('b', [_vm._v("作者之一")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2012 - 2013.")]), _vm._v(" "), _c('p', [_vm._v("策展"), _c('b', [_vm._v("小恆星＊大宇宙")]), _vm._v("每月展出一位泛自閉症孩子畫作，"), _c('br'), _vm._v("為期一年 ，共展出14位孩子的作品")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2014.05")]), _vm._v(" "), _c('p', [_vm._v("策展"), _c('b', [_vm._v("小恆星＊大宇宙")]), _vm._v("大型聯展，"), _c('br'), _vm._v("以畫作展出14位孩子與世界溝通的方式，並出版作品集")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2014.07")]), _vm._v(" "), _c('p', [_vm._v("與吳柏均巴黎旅行寫生40天，由林正盛導演拍攝"), _c('b', [_vm._v("有任務的旅行")]), _vm._v("紀錄片")])])]), _vm._v(" "), _c('div', {
    staticClass: "item wow down fadeIn",
    attrs: {
      "data-wow-duration": ".1s",
      "data-wow-delay": "0",
      "data-wow-offset": "15"
    }
  }, [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "content wow8"
  }, [_c('h5', {
    staticClass: "Montserrat"
  }, [_vm._v("2016.01")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("多寶藝術學堂")]), _vm._v("發起創辦人之一（社團法人臺灣多寶格藝術發展協會）")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551fc08f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/History.vue
// module id = 254
// module chunks = 0